import React, { useState } from 'react';
import login from '../../css/style.module.css';
import { toast } from 'react-toastify';

import img from '../../assest/logo.png';
import { useNavigate } from 'react-router-dom';
import { FaEyeSlash, FaEye } from 'react-icons/fa';

import { postApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLogin = async (event) => {
    event.preventDefault();

    if (!email || !password) {
      toast.error('Fill all the fields');
      return;
    }

    setLoading(true);

    const formData = { email, password };

    try {
      await postApi(endPoints.loginAdmin, formData, {
        setResponse: (response) => {
          sessionStorage.setItem('token', response?.accessToken);
          localStorage.setItem('token', response?.accessToken);
          toast.success('Login Successfully!');
          navigate('/dashboard');
        },
        successMsg: '',
        errorMsg: '',
      });
    } catch (error) {
      console.error('Login error:', error);
      toast.error('Failed to Login!');
    } finally {
      setLoading(false); // Ensure loading resets in both success & error
    }
  };

  return (
    <div className={login.logincontainer}>
      <div className={login.loginsubContainer}>
        <div className={login.loginlogo}>
          <img src={img} alt="Logo" />
        </div>

        <div className={login.loginheading}>
          <h3>Welcome, Log into your account</h3>
        </div>

        <div className={login.loginbox}>
          <h6>
            It is our great pleasure to have
            <br /> you on board!
          </h6>

          <div className={login.logininputs}>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter the user name"
              className={login.logininputsemail}
            />

            <div className={login.logininputspassoword}>
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder="Enter Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <div
                className={login.logininputseye}
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </div>
            </div>

            <div className={login.forgotPassword}>
              <a
                href="/forgot-password"
                style={{ color: '#F05423', cursor: 'pointer' }}
              >
                Forgot Password?
              </a>
            </div>
          </div>

          <div className={login.button1}>
            <button onClick={handleLogin} disabled={loading}>
              {loading ? 'Signing in...' : 'Sign in'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
